import { render, staticRenderFns } from "./MedflexList.vue?vue&type=template&id=52776618&scoped=true&"
import script from "./MedflexList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MedflexList.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MedflexList.vue?vue&type=style&index=0&id=52776618&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52776618",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52776618')) {
      api.createRecord('52776618', component.options)
    } else {
      api.reload('52776618', component.options)
    }
    module.hot.accept("./MedflexList.vue?vue&type=template&id=52776618&scoped=true&", function () {
      api.rerender('52776618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceCatalog/MedflexList.vue"
export default component.exports